import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from "react";
import { ProgressBar as BProgressBar } from 'react-bootstrap';
import './ProgressBar.scss';

/**
 *
 * @param {{
 * size: ("small"|"big")
 * now: number
 * label: string
 * }}
 * @returns React.Component
 */
const ProgressBar = ({ size, now, label, className, ...props }) => (
  <div className={classNames(className, "custom-progress")}>
    <BProgressBar className={classNames(size)} now={now} {...props} />
    {size !== 'small' ?
      <label> {`${now}%`} </label>
      : null}
  </div>
);

ProgressBar.propTypes = {
  className: PropTypes.any,
  size: PropTypes.string,
  now: PropTypes.number,
  label: PropTypes.string
};

ProgressBar.defaultProps = {
  className: null,
  size: 'big',
  now: 0,
  label: ''
};
export default React.memo(ProgressBar);